import React from 'react';
import { translate } from 'react-jhipster';
import { Button } from 'reactstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

export type SlotType = 'transfer' | 'purchase' | 'sell';

interface SlotProcessingDialogProps {
  open: boolean;
  slotType: SlotType | null;
  onClose: () => void;
}

const titleKey = (slotType: SlotType | null): string => {
  switch (slotType) {
    case 'transfer': return 'comexApp.quotation.slotProcessing.transferTitle';
    case 'purchase': return 'comexApp.quotation.slotProcessing.purchaseTitle';
    case 'sell':     return 'comexApp.quotation.slotProcessing.sellTitle';
    default:         return 'comexApp.quotation.slotProcessing.transferTitle';
  }
};

const messageKey = (slotType: SlotType | null): string => {
  switch (slotType) {
    case 'transfer': return 'comexApp.quotation.slotProcessing.transferMessage';
    case 'purchase': return 'comexApp.quotation.slotProcessing.purchaseMessage';
    case 'sell':     return 'comexApp.quotation.slotProcessing.sellMessage';
    default:         return 'comexApp.quotation.slotProcessing.transferMessage';
  }
};

const SlotProcessingDialog = ({ open, slotType, onClose }: SlotProcessingDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <HourglassEmptyIcon style={{ color: '#f5a623' }} />
      {translate(titleKey(slotType))}
    </DialogTitle>
    <DialogContent>
      <DialogContentText style={{ color: 'black' }}>
        {translate(messageKey(slotType))}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={onClose}>
        {translate('entity.action.ok')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default SlotProcessingDialog;
